import { CctvStatusEnum } from 'api/enums/cctv-status.enum';
import { useCallback, useState } from 'react';

const useCctvStatus = () => {
    const [status, setStatus] = useState<CctvStatusEnum>(CctvStatusEnum.LOADING);

    const setOnline = useCallback(() => {
        setStatus(CctvStatusEnum.ONLINE);
    }, []);

    const setOffline = useCallback(() => {
        setStatus(CctvStatusEnum.OFFLINE);
    }, []);

    return {
        isOnline: status === CctvStatusEnum.ONLINE,
        isOffline: status === CctvStatusEnum.OFFLINE,
        isLoading: status === CctvStatusEnum.LOADING,
        status,
        setOnline,
        setOffline,
    };
};

export default useCctvStatus;
